import { lazy } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import RoleProtected from "../components/RoleProtected.jsx";
import { Navigate } from "react-router";
import EntryApprovalList from "views/utilities/Entry Aproval Form/EntryApprovalList.js";
import VehicleGatePass from "views/utilities/Vehicle Temporary GatePass/VehicleGatePass.js";
import VisitorGatePass from "views/utilities/Visitor Temporary GatePass/VisitorGatePass.js";
import MaterialEntryExit from "views/utilities/Material Entry & Exit/MaterialEntryExit.js";
import EntryApprovalDetails from "views/utilities/Entry Aproval Form/EntryApprovalDetails.js";
import VehicleGatePassDetails from "views/utilities/Vehicle Temporary GatePass/VehicleGatePassDetails.js";
import VisitorGatePassDetails from "views/utilities/Visitor Temporary GatePass/VisitorGatePassDetails.js";
import MaterialEntryExitDetails from "views/utilities/Material Entry & Exit/MaterialEntryExitDetails.js";

import TempVisitorApproval from "views/utilities/Staff/approvals/TempVisitorApproval";
import VehicleGatePassApproval from "views/utilities/Staff/approvals/VehicleGatePassApproval.js";
import EntryApprovalStaff from "views/utilities/Staff/approvals/EntryApprovalStaff.js";
import MaterialPermitApproval from "views/utilities/Staff/approvals/MaterialPermitApproval.js";
import VisitorApprovalDetails from "views/utilities/Staff/approvals/DetailsPage/VisitorApprovalDetails.jsx";
import ChangePassword from "views/utilities/ChangePassword/ChangePassword.jsx";
import AddSubadmin from "views/utilities/Sub Admin/AddSubadmin.js";
import AllSubadminList from "views/utilities/Sub Admin/AllSubadminList.js";

// Dashboard
const Dashboard = Loadable(lazy(() => import("views/dashboard/Default")));

// Visitors
const AddVisitor = Loadable(lazy(() => import("views/utilities/Visitor/addVisitor")));
const AllVisitor = Loadable(lazy(() => import("views/utilities/Visitor/allVisitor")));
const EmployeeVisitor = Loadable(lazy(() => import("views/utilities/Visitor/employeeVisitor")));
const VehicleVisitor = Loadable(lazy(() => import("views/utilities/Visitor/vehicleVisitor")));
const VisitorHistory = Loadable(lazy(() => import("views/utilities/Visitor/visitorHistory")));
const VehicleVisitorHistory = Loadable(
  lazy(() => import("views/utilities/Visitor/VehicleGatePassHistory.js"))
);
const TempVisitorHistory = Loadable(
  lazy(() => import("views/utilities/Visitor/VisitorGatePassHistory.js"))
);
const MaterialPassHistory = Loadable(
  lazy(() => import("views/utilities/Visitor/MaterialPassHistory.js"))
);
const EntryExitPassHistory = Loadable(
  lazy(() => import("views/utilities/Visitor/EntryApprovalHistory.js"))
);

const ScanQR = Loadable(lazy(() => import("views/utilities/Visitor/scan-qr")));

const VisitorDetails = Loadable(lazy(() => import("views/utilities/Visitor/VisitorDetails.js")));

// Departments
const AddDepartment = Loadable(lazy(() => import("views/utilities/Department/AddDepartment")));
const AllDepartment = Loadable(lazy(() => import("views/utilities/Department/AllDepartment")));

// Staff
const AddStaff = Loadable(lazy(() => import("views/utilities/Staff/AddStaff")));
const AllStaff = Loadable(lazy(() => import("views/utilities/Staff/AllStaffList")));

// GateKeeper
const AddGateKeeper = Loadable(lazy(() => import("views/utilities/GateKeeper/AddGateKeeper.js")));
const AllGateKeeperList = Loadable(
  lazy(() => import("views/utilities/GateKeeper/AllGateKeeperList.js"))
);

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    // Admin routes
    {
      path: "dashboard",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <Dashboard />
        </RoleProtected>
      ),
    },
    {
      path: "users",
      element: <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>{/* Your Users Component */}</RoleProtected>,
    },
    {
      path: "add-patient",
      element: <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>{/* AddPatient Component */}</RoleProtected>,
    },
    {
      path: "add-department",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AddDepartment />
        </RoleProtected>
      ),
    },
    {
      path: "all-department",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AllDepartment />
        </RoleProtected>
      ),
    },
    {
      path: "add-staff",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AddStaff />
        </RoleProtected>
      ),
    },
    {
      path: "all-staff",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AllStaff />
        </RoleProtected>
      ),
    },
    {
      path: "add-gatekeeper",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AddGateKeeper />
        </RoleProtected>
      ),
    },
    {
      path: "all-gatekeeper",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AllGateKeeperList />
        </RoleProtected>
      ),
    },

    // Shared routes (Admin + GateKeeper)
    {
      path: "scan-qr-code",
      element: (
        <RoleProtected allowedRoles={["Admin", "GateKeeper", "SubAdmin"]}>
          <ScanQR />
        </RoleProtected>
      ),
    },
    {
      path: "visitor-history",
      element: (
        <RoleProtected allowedRoles={["Admin", "GateKeeper", "SubAdmin"]}>
          <VisitorHistory />
        </RoleProtected>
      ),
    },
    {
      path: "vehicle-visitor-history",
      element: (
        <RoleProtected allowedRoles={["Admin", "GateKeeper", "SubAdmin"]}>
          <VehicleVisitorHistory />
        </RoleProtected>
      ),
    },
    {
      path: "temp-visitor-history",
      element: (
        <RoleProtected allowedRoles={["Admin", "GateKeeper", "SubAdmin"]}>
          <TempVisitorHistory />
        </RoleProtected>
      ),
    },
    {
      path: "after-work-entry-exit-history",
      element: (
        <RoleProtected allowedRoles={["Admin", "GateKeeper", "SubAdmin"]}>
          <EntryExitPassHistory />
        </RoleProtected>
      ),
    },
    {
      path: "material-pass-history",
      element: (
        <RoleProtected allowedRoles={["Admin", "GateKeeper", "SubAdmin"]}>
          <MaterialPassHistory />
        </RoleProtected>
      ),
    },

    // Visitors (Admin only)
    {
      path: "add-visitor",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AddVisitor />
        </RoleProtected>
      ),
    },
    {
      path: "visitor-list",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <AllVisitor />
        </RoleProtected>
      ),
    },
    {
      path: "employee-visitor",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <EmployeeVisitor />
        </RoleProtected>
      ),
    },
    {
      path: "vehicle-visitor",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <VehicleVisitor />
        </RoleProtected>
      ),
    },

    {
      path: "approval-form",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <EntryApprovalList />
        </RoleProtected>
      ),
    },

    {
      path: "vehicle-gatepass",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <VehicleGatePass />
        </RoleProtected>
      ),
    },

    {
      path: "visitor-gatepass",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <VisitorGatePass />
        </RoleProtected>
      ),
    },

    {
      path: "material-entry-exit",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <MaterialEntryExit />
        </RoleProtected>
      ),
    },
    // Staff Approval Routes
    {
      path: "all-temp-visitor",
      element: (
        <RoleProtected allowedRoles={["Staff"]}>
          <TempVisitorApproval />
        </RoleProtected>
      ),
    },
    {
      path: "all-vehicle-gatepass",
      element: (
        <RoleProtected allowedRoles={["Staff"]}>
          <VehicleGatePassApproval />
        </RoleProtected>
      ),
    },
    {
      path: "all-entry-approval",
      element: (
        <RoleProtected allowedRoles={["Staff"]}>
          <EntryApprovalStaff />
        </RoleProtected>
      ),
    },
    {
      path: "all-material-permit",
      element: (
        <RoleProtected allowedRoles={["Staff"]}>
          <MaterialPermitApproval />
        </RoleProtected>
      ),
    },

    // all dyanamix routes
    {
      path: "visitor/:id",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <VisitorDetails />
        </RoleProtected>
      ),
    },
    {
      path: "entry-approval/:id",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <EntryApprovalDetails />
        </RoleProtected>
      ),
    },
    {
      path: "vehicle-gatepass/:id",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <VehicleGatePassDetails />
        </RoleProtected>
      ),
    },

    {
      path: "visitor-gatepass/:id",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <VisitorGatePassDetails />
        </RoleProtected>
      ),
    },

    {
      path: "material-permit/:id",
      element: (
        <RoleProtected allowedRoles={["Admin", "SubAdmin"]}>
          <MaterialEntryExitDetails />
        </RoleProtected>
      ),
    },

       
    // dynamic for hod approvals=>
      {
        path: "visitor-approvals-details/:id",
        element: (
          <RoleProtected allowedRoles={["Staff", "SubAdmin"]}>
            <VisitorApprovalDetails />
           </RoleProtected>
        ),
      },

      
      


      // new routes=>
      {
        path: "change-password",
        element: (
          <RoleProtected allowedRoles={["Staff", "Admin", "GateKeeper", "SubAdmin"]}>
            <ChangePassword />
          </RoleProtected>
        ),
      },
      
      {
        path: "view-subadmin",
        element: (
          <RoleProtected allowedRoles={["Admin"]}>
            <AllSubadminList />
          </RoleProtected>
        ),
      },

      {
        path: "add-subadmin",
        element: (
          <RoleProtected allowedRoles={["Admin"]}>
            <AddSubadmin />
          </RoleProtected>
        ),
      },
    

    // catch all routes
    {
      path: "*",
      element: localStorage.getItem("token") ? (
        <Navigate to="/dashboard" replace />
      ) : (
        <Navigate to="/login" replace />
      ),
    },
  ],
};

export default MainRoutes;
